<div class="wrapper">
    <div class="sidebar" data-color="azure" data-image="">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background" style="background-image: url(/assets/img/sidebar-0.jpg)"></div>
    </div>

    <div class="main-panel">
        <div class="main-content">
            <div class="myContainer card shadow">
                <div class="customContent">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="container-fluid form">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div>
                                            <div class="container-fluid" [ngClass]="{'show': !isValidResetCode, 'hide': isValidResetCode }">

                                                <div>
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <label>User: </label>
                                                        </div>
                                                        <div class="col-md-11">
                                                            <input class="form-control"
                                                                   type="email"
                                                                   name="user"
                                                                   autocomplete="on"
                                                                   readonly
                                                                   [(ngModel)]="userInfo.Email" />
                                                        </div>
                                                    </div>

                                                    <h5>Invalid reset password link</h5>

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <p>This reset password link has been redeemed or has expired. Click on Generate to get a new link.</p>
                                                            </div>
                                                        </div>

                                                    <div class="row" style="margin-top: 15px;">
                                                        <div class="col-md-2">

                                                        </div>
                                                        <div style="padding-bottom: 15px;" class="col-md-10 text-right">
                                                                <button *ngIf="!loading"  class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm readyBtn" (click)="GenerateNewLink()">
                                                                    Generate
                                                                </button>
                                                                <button *ngIf="loading" disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm readyBtn">
                                                                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Generating
                                                                </button>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>

                                            <div class="container-fluid" [ngClass]="{'show': isValidResetCode, 'hide': !isValidResetCode }">

                                                <div>
                                                    <form autocomplete="off">
                                                        <div class="row">
                                                            <div class="col-md-1">
                                                                <label>User: </label>
                                                            </div>
                                                            <div class="col-md-11">
                                                                <input class="form-control"
                                                                       type="email"
                                                                       name="user"
                                                                       autocomplete="on"
                                                                       readonly
                                                                       [(ngModel)]="userInfo.Email" />
                                                            </div>
                                                        </div>

                                                        <h5>Password</h5>

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <label>New password: </label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input class="form-control"
                                                                       #_password1
                                                                       id="password1"
                                                                       type="password"
                                                                       name="password1"
                                                                       placeholder="Password"
                                                                       autocomplete="new-password"
                                                                       [(ngModel)]="userInfo.password1"
                                                                       (keyup)="preventSpace(_password1.value, $event, 'password1')"
                                                                       (focusout)="confirmationFail()"
                                                                       (focusin)="removeMessage()"/>
                                                                <app-password-strength [passwordToCheck]="_password1.value" 
                                                                                       (passwordStrength)="passwordValid($event)">
                                                                </app-password-strength>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <label>Confirm password: </label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input class="form-control pass2"
                                                                       #_password2
                                                                       id="password2"
                                                                       type="password"
                                                                       name="password2"
                                                                       placeholder="Confirm password"
                                                                       autocomplete="new-password"
                                                                       [(ngModel)]="userInfo.password2"
                                                                       (keyup)="preventSpace(_password2.value, $event, 'password2')"
                                                                       (focusout)="confirmationFail()"
                                                                       (focusin)="removeMessage()" />
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <span id="errorPasswordMessage"></span>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-md-2">
                                                            </div>
                                                            <div style="padding-bottom: 15px;" class="col-md-10 text-right">
                                                                <input type="submit"
                                                                       class="btn btn-primary submit"
                                                                       value="Update Password"
                                                                       [disabled]="!validForm() || !passwordIsValid"
                                                                       (click)="updatePassword()" />
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
        </div>
    </div>
</div>
